import {useState} from 'react';
import {useResetPasswordMutation} from '../../redux/services/authApi';

import useError from '../../hooks/useError';
import ResetPasswordForm from '../../components/auth/ResetPasswordForm';
import AuthLayout from "../../components/auth/AuthLayout";

const handleSubmit = ({
  resetPassword,
  setIsSubmitting,
  setSuccess,
  setError,
}) => async formData => {
  setIsSubmitting(true);
  const res = await resetPassword(formData);
  setIsSubmitting(false);
  if (res.error) return setError({message: 'Error resetting password'});
  return setSuccess(true);
};

const ResetPasswordPage = props => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resetPassword] = useResetPasswordMutation();
  const errors = useError();
  const childProps = {
    isSubmitting,
    success,
    onSubmit: handleSubmit({
      resetPassword,
      setIsSubmitting,
      setSuccess,
      setError: errors.create,
    }),
  };

  return (
    <AuthLayout {...childProps}
                title={'Reset Password'}
                showLoginBtn={false}
    >
      <ResetPasswordForm {...childProps} />
    </AuthLayout>
  );
};

export default ResetPasswordPage;
